<div class="filter-container">
  <span (click)="openCompanyFilterDialog()" class="indicator-filter">
    <mat-icon aria-hidden="false">filter_alt</mat-icon>
    <div class="selected-value-container">
      <span [matTooltip]="getFilterValue()">{{ getFilterValue() }}</span>
    </div>
  </span>
  <span (click)="clearFilter()" class="clear-filter">
    <mat-icon aria-hidden="false">filter_alt_off</mat-icon>
  </span>
</div>
